import React, { useRef, useEffect } from "react";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import "./LarchErp.css";
import { FaCogs, FaUsers, FaBalanceScale, FaChartBar } from "react-icons/fa";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

import collab from "../../assets/collab.png";
import portfolio1 from "../../assets/Company.jpg";
import portfolio2 from "../../assets/Company2.jpg";
import portfolio3 from "../../assets/Company3.jpg";
import portfolio4 from "../../assets/Company4.jpg";
import success1 from "../../assets/Company5.jpg";
import success2 from "../../assets/health.png";
import success3 from "../../assets/retail.png";
import ERPChatbot from "../../components/ERPChatbot/ERPChatbot";

function LarchErp() {
  const sliderRef = useRef(null);
  const intervalRef = useRef(null);

  const stories = [
    {
      bgImage: success1,
      name: "Donga India Automotive Pvt Ltd",
      story:
        "Larch ERP has been a game-changer for our business! The implementation team did an excellent job understanding our needs and delivering a tailored solution. The phased rollout ensured a smooth transition, and the benefits were evident from the start. We're thrilled with the results and grateful for the team's expertise and support throughout the 2-year journey.",
      person: "Alice Johnson",
      position: "Supply Chain Manager",
    },
    {
      bgImage: success2,
      name: "Korea Fuel Tech India Private Limited",
      story:
        "We're extremely satisfied with Larch ERP's implementation. Their collaborative approach and phased delivery ensured a smooth transition. The system has brought significant efficiency gains and improved decision-making across our organization.",
      person: "David Smith",
      position: "CFO",
    },
    {
      bgImage: success3,
      name: "	YJ Polytec Private",
      story:
        "Larch ERP's implementation was a game-changer! Their meticulous planning, collaborative approach, and phased rollout delivered significant benefits from day one. We're thrilled with the results and grateful for their expertise.",
      person: "Emma Williams",
      position: "Operations Head",
    },
     {
      bgImage: success3,
      name: "CJ Polytech Private Limited  and Yeemak India Private Limited",
      story:
        "We're impressed with Larch ERP's Purchase and Inventory module implementation. Their thorough planning, collaborative approach, and phased rollout delivered significant benefits within just 4 months. The tailored solutions have greatly improved our operations, and we're thrilled with the results",
      person: "Emma Williams",
      position: "Operations Head",
    },
  ];

  const getGap = (container) => {
    if (!container) return 32;
    try {
      const gs = window.getComputedStyle(container);
      const gapStr =
        gs.getPropertyValue("gap") ||
        gs.getPropertyValue("column-gap") ||
        gs.getPropertyValue("grid-column-gap") ||
        "32px";
      const g = parseFloat(gapStr);
      return Number.isFinite(g) ? g : 32;
    } catch {
      return 32;
    }
  };

  const handleScroll = (direction) => {
    const slider = sliderRef.current;
    if (!slider) return;
    const card = slider.querySelector(".success-card.full-card");
    const gap = getGap(slider);
    const amount = (card?.offsetWidth || 700) + gap;
    slider.scrollBy({
      left: direction === "left" ? -amount : amount,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    const slider = sliderRef.current;
    if (!slider) return;
    const card = slider.querySelector(".success-card.full-card");
    if (!card) return;
    const totalCards = stories.length;
    let index = 0;

    const startAutoScroll = () => {
      clearInterval(intervalRef.current);
      intervalRef.current = setInterval(() => {
        index++;
        if (index >= totalCards) index = 0;

        const currentCard = slider.querySelector(".success-card.full-card");
        const gap = getGap(slider);
        const cardWidth =
          (currentCard?.offsetWidth || card.offsetWidth) + gap;

        slider.scrollTo({ left: cardWidth * index, behavior: "smooth" });
      }, 4000);
    };

    const stopAutoScroll = () => {
      clearInterval(intervalRef.current);
    };

    startAutoScroll();
    slider.addEventListener("mouseenter", stopAutoScroll);
    slider.addEventListener("mouseleave", startAutoScroll);
    slider.addEventListener("touchstart", stopAutoScroll, { passive: true });
    slider.addEventListener("touchend", startAutoScroll, { passive: true });

    return () => {
      clearInterval(intervalRef.current);
      slider.removeEventListener("mouseenter", stopAutoScroll);
      slider.removeEventListener("mouseleave", startAutoScroll);
      slider.removeEventListener("touchstart", stopAutoScroll);
      slider.removeEventListener("touchend", startAutoScroll);
    };
  }, [stories.length]);

   useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Header />

      <div className="larcherp-page">
        {/* Hero Section */}
        <section
          className="larcherp-hero"
          style={{ backgroundImage: `url(${collab})` }}
        >
          <div className="larcherp-hero-overlay"></div>
          <h1 className="larcherp-hero-title">Enterprise Resource Planning (ERP)</h1>
          <p className="larcherp-hero-subtitle">
            Integrated Solutions for Business Efficiency
          </p>
        </section>

        {/* Intro */}
        <section className="larcherp-intro">
          <h2>What is ERP?</h2>
          <p>
            <strong>
              Enterprise Resource Planning (ERP) systems unify and streamline
              core business processes across finance, HR, supply chain, and
              operations.
            </strong>
          </p>
          <p>
            <strong>
              ERP ensures seamless information flow across departments,
              enabling real-time decision-making and boosting organizational
              productivity.
            </strong>
          </p>
        </section>

        {/* Benefits */}
{/* Benefits Section */}
<section className="larcherp-benefits">
  <h2>Key Benefits of Larch ERP</h2>
  <div className="larcherp-benefit-cards">
    <div className="larcherp-benefit-card">
      <FaCogs className="benefit-icon" />
      <h3>Process Automation</h3>
      <p>Automate repetitive tasks and free up resources for innovation.</p>
    </div>
    <div className="larcherp-benefit-card">
      <FaUsers className="benefit-icon" />
      <h3>Collaboration</h3>
      <p>Unify departments and improve collaboration with centralized data.</p>
    </div>
    <div className="larcherp-benefit-card">
      <FaBalanceScale className="benefit-icon" />
      <h3>Compliance</h3>
      <p>Ensure adherence to regulations with audit-ready records.</p>
    </div>
    <div className="larcherp-benefit-card">
      <FaChartBar className="benefit-icon" />
      <h3>Data Insights</h3>
      <p>Make data-driven decisions with advanced analytics and dashboards.</p>
    </div>
  </div>
</section>


        {/* Portfolio */}
        <section className="larcherp-portfolio">
          <h2 className="larcherp-portfolio-title">Our ERP Portfolio</h2>
          <div className="larcherp-portfolio-grid">
            <div className="larcherp-portfolio-card">
              <img src={portfolio1} alt="ERP Portfolio 1" />
              <h3>Erp for Manufacturing</h3>
               <Link to="/CableAssembly" className="explore-link">
    Explore More →
  </Link>
            </div>
            <div className="larcherp-portfolio-card">
              <img src={portfolio2} alt="ERP Portfolio 2" />
              <h3>ERP for Wirring Harness</h3>
               <Link to="/CableAssembly" className="explore-link">
    Explore More →
  </Link>
            </div>
            <div className="larcherp-portfolio-card">
              <img src={portfolio3} alt="ERP Portfolio 3" />
              <h3>ERP for Rubber Products</h3>
               <Link to="/CableAssembly" className="explore-link">
    Explore More →
  </Link>
            </div>
            <div className="larcherp-portfolio-card">
              <img src={portfolio4} alt="ERP Portfolio 4" />
              <h3>ERP for Injection Moulding</h3>
               <Link to="/CableAssembly" className="explore-link">
                  Explore More →
                </Link>
            </div>
          </div>
        </section>

        {/* Success Stories */}
        <section className="success-section">
          <motion.h2
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            ERP Success Stories
          </motion.h2>

          <div className="success-slider-wrapper">
            <button className="scroll-btn left" onClick={() => handleScroll("left")}>
              ‹
            </button>

            <div className="success-slider-scrollable" ref={sliderRef}>
              {stories.map((item, i) => (
                <div
                  key={i}
                  className="success-card full-card"
                  style={{
                    backgroundImage: `url(${item.bgImage})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                  }}
                >
                  <div className="success-overlay" />
                  <div className="success-content">
                    <h3>{item.name}</h3>
                    <p>“{item.story}”</p>
                    <p className="person">{item.person}</p>
                    <p className="position">{item.position}</p>
                  </div>
                </div>
              ))}
            </div>

            <button className="scroll-btn right" onClick={() => handleScroll("right")}>
              ›
            </button>
          </div>
        </section>
      </div>

      <Footer />
        <ERPChatbot />
    </>
  );
}

export default LarchErp;
